module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 9);
}([function (e, t, n) {
  "use strict";

  function r(e) {
    return function () {
      return e;
    };
  }

  var o = function o() {};

  o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
    return this;
  }, o.thatReturnsArgument = function (e) {
    return e;
  }, e.exports = o;
}, function (e, t, n) {
  "use strict";

  var r = function r(e) {};

  e.exports = function (e, t, n, o, i, u, c, a) {
    if (r(t), !e) {
      var f;
      if (void 0 === t) f = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var l = [n, o, i, u, c, a],
            s = 0;
        (f = new Error(t.replace(/%s/g, function () {
          return l[s++];
        }))).name = "Invariant Violation";
      }
      throw f.framesToPop = 1, f;
    }
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  var r = n(0),
      o = n(1),
      i = n(2);

  e.exports = function () {
    function e(e, t, n, r, u, c) {
      c !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  e.exports = n(3)();
}, function (e, t, n) {
  "use strict";

  e.exports = {};
}, function (e, t, n) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;
  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, u, c = function (e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }(e), a = 1; a < arguments.length; a++) {
      for (var f in n = Object(arguments[a])) {
        o.call(n, f) && (c[f] = n[f]);
      }

      if (r) {
        u = r(n);

        for (var l = 0; l < u.length; l++) {
          i.call(n, u[l]) && (c[u[l]] = n[u[l]]);
        }
      }
    }

    return c;
  };
}, function (e, t, n) {
  "use strict";
  /** @license React v16.4.0
   * react.production.min.js
   *
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var r = n(6),
      o = n(1),
      i = n(5),
      u = n(0),
      c = "function" == typeof Symbol && Symbol.for,
      a = c ? Symbol.for("react.element") : 60103,
      f = c ? Symbol.for("react.portal") : 60106,
      l = c ? Symbol.for("react.fragment") : 60107,
      s = c ? Symbol.for("react.strict_mode") : 60108,
      p = c ? Symbol.for("react.profiler") : 60114,
      d = c ? Symbol.for("react.provider") : 60109,
      y = c ? Symbol.for("react.context") : 60110,
      b = c ? Symbol.for("react.async_mode") : 60111,
      h = c ? Symbol.for("react.forward_ref") : 60112;
  c && Symbol.for("react.timeout");
  var v = "function" == typeof Symbol && Symbol.iterator;

  function m(e) {
    for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
      n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
    }

    o(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
  }

  var g = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  };

  function _(e, t, n) {
    this.props = e, this.context = t, this.refs = i, this.updater = n || g;
  }

  function w() {}

  function S(e, t, n) {
    this.props = e, this.context = t, this.refs = i, this.updater = n || g;
  }

  _.prototype.isReactComponent = {}, _.prototype.setState = function (e, t) {
    "object" != typeof e && "function" != typeof e && null != e && m("85"), this.updater.enqueueSetState(this, e, t, "setState");
  }, _.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, w.prototype = _.prototype;
  var O = S.prototype = new w();
  O.constructor = S, r(O, _.prototype), O.isPureReactComponent = !0;
  var j = {
    current: null
  },
      P = Object.prototype.hasOwnProperty,
      k = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function x(e, t, n) {
    var r = void 0,
        o = {},
        i = null,
        u = null;
    if (null != t) for (r in void 0 !== t.ref && (u = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
      P.call(t, r) && !k.hasOwnProperty(r) && (o[r] = t[r]);
    }
    var c = arguments.length - 2;
    if (1 === c) o.children = n;else if (1 < c) {
      for (var f = Array(c), l = 0; l < c; l++) {
        f[l] = arguments[l + 2];
      }

      o.children = f;
    }
    if (e && e.defaultProps) for (r in c = e.defaultProps) {
      void 0 === o[r] && (o[r] = c[r]);
    }
    return {
      $$typeof: a,
      type: e,
      key: i,
      ref: u,
      props: o,
      _owner: j.current
    };
  }

  function R(e) {
    return "object" == typeof e && null !== e && e.$$typeof === a;
  }

  var E = /\/+/g,
      T = [];

  function C(e, t, n, r) {
    if (T.length) {
      var o = T.pop();
      return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
    }

    return {
      result: e,
      keyPrefix: t,
      func: n,
      context: r,
      count: 0
    };
  }

  function I(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > T.length && T.push(e);
  }

  function $(e, t, n, r) {
    var o = typeof e;
    "undefined" !== o && "boolean" !== o || (e = null);
    var i = !1;
    if (null === e) i = !0;else switch (o) {
      case "string":
      case "number":
        i = !0;
        break;

      case "object":
        switch (e.$$typeof) {
          case a:
          case f:
            i = !0;
        }

    }
    if (i) return n(r, e, "" === t ? "." + M(e, 0) : t), 1;
    if (i = 0, t = "" === t ? "." : t + ":", Array.isArray(e)) for (var u = 0; u < e.length; u++) {
      var c = t + M(o = e[u], u);
      i += $(o, c, n, r);
    } else if (null === e || void 0 === e ? c = null : c = "function" == typeof (c = v && e[v] || e["@@iterator"]) ? c : null, "function" == typeof c) for (e = c.call(e), u = 0; !(o = e.next()).done;) {
      i += $(o = o.value, c = t + M(o, u++), n, r);
    } else "object" === o && m("31", "[object Object]" === (n = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : n, "");
    return i;
  }

  function M(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return t[e];
      });
    }(e.key) : t.toString(36);
  }

  function A(e, t) {
    e.func.call(e.context, t, e.count++);
  }

  function N(e, t, n) {
    var r = e.result,
        o = e.keyPrefix;
    e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? V(e, r, n, u.thatReturnsArgument) : null != e && (R(e) && (t = o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(E, "$&/") + "/") + n, e = {
      $$typeof: a,
      type: e.type,
      key: t,
      ref: e.ref,
      props: e.props,
      _owner: e._owner
    }), r.push(e));
  }

  function V(e, t, n, r, o) {
    var i = "";
    null != n && (i = ("" + n).replace(E, "$&/") + "/"), t = C(t, i, r, o), null == e || $(e, "", N, t), I(t);
  }

  var q = {
    Children: {
      map: function map(e, t, n) {
        if (null == e) return e;
        var r = [];
        return V(e, r, null, t, n), r;
      },
      forEach: function forEach(e, t, n) {
        if (null == e) return e;
        t = C(null, null, t, n), null == e || $(e, "", A, t), I(t);
      },
      count: function count(e) {
        return null == e ? 0 : $(e, "", u.thatReturnsNull, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return V(e, t, null, u.thatReturnsArgument), t;
      },
      only: function only(e) {
        return R(e) || m("143"), e;
      }
    },
    createRef: function createRef() {
      return {
        current: null
      };
    },
    Component: _,
    PureComponent: S,
    createContext: function createContext(e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: y,
        _calculateChangedBits: t,
        _defaultValue: e,
        _currentValue: e,
        _currentValue2: e,
        _changedBits: 0,
        _changedBits2: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: d,
        _context: e
      }, e.Consumer = e;
    },
    forwardRef: function forwardRef(e) {
      return {
        $$typeof: h,
        render: e
      };
    },
    Fragment: l,
    StrictMode: s,
    unstable_AsyncMode: b,
    unstable_Profiler: p,
    createElement: x,
    cloneElement: function cloneElement(e, t, n) {
      (null === e || void 0 === e) && m("267", e);
      var o = void 0,
          i = r({}, e.props),
          u = e.key,
          c = e.ref,
          f = e._owner;

      if (null != t) {
        void 0 !== t.ref && (c = t.ref, f = j.current), void 0 !== t.key && (u = "" + t.key);
        var l = void 0;

        for (o in e.type && e.type.defaultProps && (l = e.type.defaultProps), t) {
          P.call(t, o) && !k.hasOwnProperty(o) && (i[o] = void 0 === t[o] && void 0 !== l ? l[o] : t[o]);
        }
      }

      if (1 === (o = arguments.length - 2)) i.children = n;else if (1 < o) {
        l = Array(o);

        for (var s = 0; s < o; s++) {
          l[s] = arguments[s + 2];
        }

        i.children = l;
      }
      return {
        $$typeof: a,
        type: e.type,
        key: u,
        ref: c,
        props: i,
        _owner: f
      };
    },
    createFactory: function createFactory(e) {
      var t = x.bind(null, e);
      return t.type = e, t;
    },
    isValidElement: R,
    version: "16.4.0",
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      ReactCurrentOwner: j,
      assign: r
    }
  },
      U = {
    default: q
  },
      B = U && q || U;
  e.exports = B.default ? B.default : B;
}, function (e, t, n) {
  "use strict";

  e.exports = n(7);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      i = c(n(8)),
      u = c(n(4));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var a = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.addMainScript = n.addMainScript.bind(n), n.addIdentityVariables = n.addIdentityVariables.bind(n), n.insertScript = n.insertScript.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.default.Component), o(t, [{
      key: "insertScript",
      value: function value(e) {
        var t = document.createElement("script");
        t.innerText = e, t.async = !0, document.body.appendChild(t);
      }
    }, {
      key: "addMainScript",
      value: function value() {
        var e = '!function() {\n        var t = window.driftt = window.drift = window.driftt || [];\n        if (!t.init) {\n          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));\n          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], \n          t.factory = function(e) {\n            return function() {\n              var n = Array.prototype.slice.call(arguments);\n              return n.unshift(e), t.push(n), t;\n            };\n          }, t.methods.forEach(function(e) {\n            t[e] = t.factory(e);\n          }), t.load = function(t) {\n            var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");\n            o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";\n            var i = document.getElementsByTagName("script")[0];\n            i.parentNode.insertBefore(o, i);\n          };\n        }\n      }();\n      drift.SNIPPET_VERSION = \'0.3.1\';\n      drift.load(\'' + this.props.appId + "');";
        this.insertScript(e);
      }
    }, {
      key: "addIdentityVariables",
      value: function value() {
        if (!r(this.props.userId)) {
          var e = "\n        var t = window.driftt = window.drift = window.driftt || [];\n        drift.identify('" + this.props.userId + "', '" + this.props.attributes + "')\n      ";
          this.insertScript(e);
        }
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        void 0 !== ("undefined" == typeof window ? "undefined" : r(window)) && (this.addMainScript(), this.addIdentityVariables());
      }
    }, {
      key: "render",
      value: function value() {
        return "";
      }
    }]), t;
  }(),
      f = {
    appId: u.default.string.isRequired,
    attributes: u.default.object
  };

  a.propTypes = f, t.default = a;
}]);